export function trackGA4PageView(to, from) {
  const gtagID = process.env.VUE_APP_GTAG_ID
  if (window.gtag && gtagID) {
    gtag('config', gtagID, {
      send_page_view: false,
      page_referrer: from.fullPath || from.path,
      page_location: to.fullPath || to.path,
      page_title: to.path || to.name,
      update: true
    })
    gtag('event', 'page_view')
  }
}

export function addTrackGA4PageViewListener(router) {
  router.afterEach(trackGA4PageView)
}
